import { render, staticRenderFns } from "./HelpBox.vue?vue&type=template&id=2308685a&"
var script = {}
import style0 from "./HelpBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports